import { Grid, withStyles } from '@material-ui/core';
import React from 'react';
import { ToggleUI } from '../../common';

const SuccessSuscriptionMessage_ = ({ show, classes, t_deuda }) => {
  const title = t_deuda
    ? '¡El débito automático se activó con éxito!'
    : 'Estamos procesando el pago de tu débito automático';

  const subtitle = t_deuda
    ? `Tu tienda se reactivará cuando ingrese el pago, esto puede demorar hasta 48 horas.`
    : '';

  const paragraph = t_deuda
    ? `Para evitar errores, te sugerimos no modificar datos de tu suscripción hasta que se reactive tu tienda.`
    : `Para evitar errores, te sugerimos no modificar datos de tu suscripción hasta que finalice el proceso. Esto puede demorar hasta 48 horas.`;

  return (
    <ToggleUI show={show}>
      <Grid item xs={12} className={classes.container}>
        <>
          <p className={classes.titleParagraph}>{title}</p>
          <p className={classes.paragraph}>
            {subtitle}
            {!!subtitle && ' '}
            <span className={classes.paragraph} style={{ fontWeight: 500 }}>
              {paragraph}
            </span>
          </p>
        </>
      </Grid>
    </ToggleUI>
  );
};

const styles = (theme) => ({
  container: {
    padding: '24px',
    borderRadius: '4px',
    marginBottom: '30px',
    backgroundColor: '#fff',
    border: `2px solid ${theme.palette.primary.main}`,
  },
  titleParagraph: {
    color: '#53B755',
    fontSize: '1.125rem',
    fontWeight: '500',
    margin: '0 0 8px',
  },
  paragraph: {
    color: '#565656',
    fontSize: '1rem',
    margin: 0,
  },
});

export const SuccessSuscriptionMessage = withStyles(styles)(
  SuccessSuscriptionMessage_
);
